import { cn } from '@/lib/utils';
import { Video } from '@/queries/media/types';

interface HomeHighlightsListProps {
  className?: string;
  highlights: Video[] | undefined;
  currentHighlightIndex?: number;
  onHighlightClick: (highlight: Video) => void;
}

const HomeHighlightsList = ({ className, highlights, currentHighlightIndex, onHighlightClick }: HomeHighlightsListProps) => {
  return (
    <ul className={cn('preflight preflight-ul grid grid-cols-1 gap-6 desktop:grid-cols-3 desktop:gap-3', className)}>
      {highlights?.map((highlight, index) => (
        <li key={highlight._id}>
          <a
            data-native
            href={`/highlights?id=${highlight._id}`}
            aria-disabled={highlight.disabled}
            className="preflight preflight-a gap-4 transition-opacity hover:opacity-80 aria-disabled:opacity-50 mobile:grid mobile:grid-cols-[150px_1fr]"
            onClick={(e) => {
              e.preventDefault();
              onHighlightClick(highlight);
            }}
          >
            <div className="preflight relative overflow-hidden rounded desktop:rounded-lg">
              <img
                className="preflight preflight-img aspect-video"
                src={highlight.thumbnailURL}
                alt={highlight.title}
                loading="lazy"
              />
              {currentHighlightIndex === index && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/75">
                  <div className="flex h-6 items-end gap-0.5 desktop:h-10">
                    <span className="h-[60%] w-2 animate-soundbar bg-white desktop:w-4" />
                    <span className="h-[30%] w-2 animate-soundbar bg-white [animation-delay:-2.2s] desktop:w-4" />
                    <span className="h-[75%] w-2 animate-soundbar bg-white [animation-delay:-3.7s] desktop:w-4" />
                  </div>
                </div>
              )}
            </div>
            <div className="desktop:hidden">
              <h5 className="preflight preflight-h5 text-sm font-semibold">{highlight.title}</h5>
              <p className="preflight preflight-p mt-1 text-xs font-light">
                {highlight.type === 'curated' ? 'Added by zoolife' : `Taken by @${highlight.username}`}
              </p>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default HomeHighlightsList;
